import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
	width: 100%;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }
`;